import { useAuth } from '@verantos-dev/core-auth';

import { useAnalysisProfileQuery } from '../api/useAnalysisProfileQuery';
import type { UseAnalysisEditLockResult } from '../types';
import { useAnalysisRouteParams } from './useAnalysisRouteParams';

// Single edit-lock gate for the analysis definition. Editing is locked when the
// current user didn't create the analysis, or its latest run is in flight.
// Locked-until-known: while the profile is loading `isOwner` is false, so
// affordances stay disabled.
export const useAnalysisEditLock = (): UseAnalysisEditLockResult => {
  const {
    user: { auth0Id, userId },
  } = useAuth();
  const { projectId, analysisProfileId } = useAnalysisRouteParams();
  const { data } = useAnalysisProfileQuery({ projectId, analysisProfileId });
  const profile = data?.data;

  const isProcessing = profile?.latestStatus === 'PROCESSING';
  const ownerUserId = profile?.createdBy?.userId;
  const isOwner = !!ownerUserId && [auth0Id, userId].includes(ownerUserId);

  return { isEditDisabled: !isOwner || isProcessing, isProcessing, isOwner };
};
